import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxFileUploaderComponent } from 'devextreme-angular';
import {
  FileUploaderStyle,
  UploadMethod,
  UploadMode,
  UploadValidationStatus,
} from '../../../base/src/abcFileUploader/abcFileUploader';

@Component({
  selector: '',
  template: ` <div class="devExFileUploaderStyle" [class]="{ avatar: showAvatar }">
    <dx-file-uploader
      #devExFileUploader
      [id]="id"
      [height]="height"
      [width]="width"
      [selectButtonText]="selectButtonText"
      [labelText]="labelText"
      [accept]="accept"
      [name]="name"
      [class]="class"
      [uploadMode]="uploadMode"
      [activeStateEnabled]="activeStateEnabled"
      [hoverStateEnabled]="hoverStateEnabled"
      [allowCanceling]="allowCanceling"
      [disabled]="disabled"
      [focusStateEnabled]="focusStateEnabled"
      [visible]="visible"
      [readOnly]="readOnly"
      [rtlEnabled]="rtlEnabled"
      [isValid]="isValid"
      [maxFileSize]="maxFileSize"
      [minFileSize]="minFileSize"
      [multiple]="multiple"
      [dropZone]="dropZone"
      [showFileList]="showFileList"
      [tabIndex]="tabIndex"
      [uploadButtonText]="uploadButtonText"
      [uploadedMessage]="uploadedMessage"
      [uploadFailedMessage]="uploadFailedMessage"
      [uploadUrl]="uploadUrl"
      [uploadMethod]="uploadMethod"
      [validationStatus]="validationStatus"
      [dialogTrigger]="dialogTrigger"
      [allowedFileExtensions]="allowedFileExtensions"
      [readyToUploadMessage]="readyToUploadMessage"
      (onOptionChanged)="onFileChanged($event)"
      (onDropZoneEnter)="onDropZoneEnter($event)"
      (onDropZoneLeave)="onDropZoneLeave($event)"
      (onUploaded)="onUploaded($event)"
      (onProgress)="onProgress($event)"
      (onUploadStarted)="onUploadStarted($event)"
    >
    </dx-file-uploader>

    <div class="widget-container avatar-container" *ngIf="showAvatar">
      <div
        id="dropzone-external"
        [ngClass]="
          isDropZoneActive ? ['dx-theme-accent-as-border-color', 'dropzone-active'] : ['dx-theme-border-color']
        "
      >
        <div id="dropzone-text" class="user-avatar" *ngIf="textVisible">
          <mat-icon svgIcon="user"></mat-icon>
        </div>
        <img id="dropzone-image" [src]="imageSource" *ngIf="imageSource" alt="" />
      </div>
    </div>
  </div>`,
  styleUrls: ['./devFileUploader.component.scss'],
})
export class DevExFileUploaderComponent implements OnInit {
  @ViewChild('devExFileUploader', { static: true }) public devExFileUploader: DxFileUploaderComponent;
  @Input() id: string;
  @Input() height: string;
  @Input() width: string;
  @Input() labelText: string;
  @Input() selectButtonText: string;
  @Input() accept: string;
  @Input() uploadMode: UploadMode;
  @Input() activeStateEnabled: boolean;
  @Input() hoverStateEnabled: boolean;
  @Input() allowCanceling: boolean;
  @Input() class: string;
  @Input() disabled: boolean;
  @Input() focusStateEnabled: boolean;
  @Input() isValid: boolean;
  @Input() maxFileSize: number;
  @Input() minFileSize: number;
  @Input() multiple: boolean;
  @Input() readOnly: boolean;
  @Input() name: string = '';
  @Input() invalidFileExtensionMessage: string;
  @Input() invalidMaxFileSizeMessage: string;
  @Input() invalidMinFileSizeMessage: string;
  @Input() readyToUploadMessage: string;
  @Input() rtlEnabled: false;
  @Input() showFileList: boolean;
  @Input() tabIndex: number;
  @Input() uploadButtonText: string = 'Upload';
  @Input() uploadAbortedMessage: string;
  @Input() uploadedMessage: string;
  @Input() uploadFailedMessage: string;
  @Input() uploadUrl: string;
  @Input() uploadMethod: UploadMethod;
  @Input() validationStatus: UploadValidationStatus;
  @Input() dialogTrigger: string;
  @Input() dropZone: string;
  @Input() allowedFileExtensions: string[] = ['.jpg', '.jpeg', '.gif', '.png', '.svg'];
  @Input() visible: boolean = true;
  @Input() showAvatar: boolean;
  @Input() value: any;
  @Output() onFileUploaded = new EventEmitter();
  @Output() onImgUploaded = new EventEmitter();
  public isDropZoneActive = false;
  public imageSource = '';
  public textVisible = true;
  public progressVisible = false;
  public progressValue = 0;

  private isUploaded: boolean = false;
  constructor() {}
  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  ngAfterContentChecked() {
    if (this.value && !this.isUploaded) {
      this.imageSource = this.value;
    }
  }

  public onFileChanged(ev): void {
    this.isUploaded = true;
    const file = ev.value[0];   
    const reader = new FileReader();   
    reader.readAsDataURL(new Blob([file]));
    reader.onloadend = (e) => {
      this.onFileUploaded.emit({ docDetails: ev.value[0], baseUrl: reader.result });
    };
    reader.onerror = (error) => {
      console.log('Error: ', error);
    };
  }

  public setFileUploaderStyle(style: FileUploaderStyle): void {
    if (style) {
      for (let key in style) {
        this[key] = style[key];
      }
    }
  }

  onDropZoneEnter(ev): void {
    if (ev.dropZoneElement.id === 'dropzone-external') this.isDropZoneActive = true;
  }

  onDropZoneLeave(e): void {
    if (e.dropZoneElement.id === 'dropzone-external') this.isDropZoneActive = false;
  }

  onUploaded(ev): void {
    const file = ev.file;
    const fileReader = new FileReader();
    fileReader.onload = () => {
      this.isDropZoneActive = false;
      this.imageSource = fileReader.result as string;
      this.onImgUploaded.emit(this.imageSource);
    };
    fileReader.readAsDataURL(file);
  }

  onProgress(ev): void {
    this.progressValue = (ev.bytesLoaded / ev.bytesTotal) * 100;
  }

  onUploadStarted(ev): void {
    this.imageSource = '';
    this.progressVisible = true;
  }
}
